export const DEFAULT_LANGUAGE = navigator.language.split('-')[0]
export const FALLBACK_LANGUAGE = 'pl'
export const SUPPORTED_LANGUAGES = ['pl', 'en']



// WEBPACK FOOTER //
// ./src/constants/trans.js